import type { AgentToolConfigArg } from '@takeshape/schema';
import type { ImmutableMap } from 'app/common/utils/immutable-types';
import type { WidgetProps } from 'app/schema-form/types';

export const ToolArgumentPreview = ({ value }: WidgetProps) => {
  return (value as ImmutableMap<AgentToolConfigArg>).get('argName');
};
